/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Caveat_CodInputs */

const vi_cashflow_caveat_cod = /** @type {(inputs: Cashflow_Caveat_CodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền mặt vào CHƯA gồm tiền COD tài xế thu hộ (chưa được ghi nhận).`)
};

/**

* @param {Cashflow_Caveat_CodInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_caveat_cod = /** @type {((inputs?: Cashflow_Caveat_CodInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Caveat_CodInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_caveat_cod(inputs)
});